import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import StackView from '../StackView';
import Text from '../Text';

var BodyInnerCell = function BodyInnerCell(_ref) {
  var children = _ref.children,
      column = _ref.column,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "column"]);

  return /*#__PURE__*/React.createElement(StackView, _extends({
    axis: "horizontal",
    alignment: "center",
    width: column.width || column.maxWidth || column.truncate ? '100%' : undefined,
    paddingHorizontal: 1.5
  }, restProps), column.truncate ? /*#__PURE__*/React.createElement(Text, {
    as: "div",
    truncate: true
  }, children) : children);
};

export default BodyInnerCell;